export default __webpack_public_path__ + "static/cercle_vicieux_it-fff231c994c589ea24a4fb8383607c10.mp4";